import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/solid/{S,M,L}/home.svg` */
export const HomeSolidIcon = createTripletGlyphIcon('HomeSolidIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.0166 1.64921C7.4569 1.22925 8.14609 1.21822 8.59961 1.62382L14.1553 6.59745C14.4023 6.81875 14.5439 7.13495 14.5439 7.46659V13.7478C14.5438 14.392 14.0211 14.9147 13.377 14.9148H10.5527C9.9085 14.9148 9.38584 14.3921 9.38574 13.7478V10.241C9.38574 10.1491 9.31155 10.0743 9.21973 10.074H6.87012C6.77823 10.0742 6.7041 10.1491 6.7041 10.241V13.7478C6.704 14.392 6.18126 14.9147 5.53711 14.9148H2.62402C1.97975 14.9148 1.45713 14.3921 1.45703 13.7478V7.4539C1.45704 7.13506 1.58771 6.83028 1.81836 6.61015L7.0166 1.64921Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.89258 1.71949C8.38801 1.24672 9.16452 1.23451 9.6748 1.69117L15.9238 7.28589C16.2019 7.53484 16.3613 7.89119 16.3613 8.26441V15.3308C16.3612 16.0555 15.7735 16.6432 15.0488 16.6433H11.8711C11.1465 16.6431 10.5587 16.0554 10.5586 15.3308V11.3855C10.5585 11.282 10.4746 11.198 10.3711 11.198H7.72852C7.6252 11.1982 7.5411 11.2822 7.54102 11.3855V15.3308C7.54088 16.0556 6.95331 16.6433 6.22852 16.6433H2.95117C2.22644 16.6432 1.6388 16.0555 1.63867 15.3308V8.24976C1.63876 7.8912 1.78555 7.54813 2.04492 7.30054L7.89258 1.71949Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5244 2.29323C11.1851 1.66312 12.2201 1.64615 12.9004 2.25515L21.2324 9.71511C21.6031 10.047 21.8154 10.5213 21.8154 11.0188V20.4407C21.8154 21.407 21.0317 22.1904 20.0654 22.1907H15.8291C14.8627 22.1906 14.0791 21.4072 14.0791 20.4407V15.18C14.079 15.0421 13.9669 14.9302 13.8291 14.93H10.3057C10.1677 14.93 10.0558 15.042 10.0557 15.18V20.4407C10.0557 21.407 9.27194 22.1904 8.30566 22.1907H3.93555C2.96905 22.1907 2.18457 21.4072 2.18457 20.4407V11.0003C2.18463 10.522 2.38154 10.0638 2.72754 9.73366L10.5244 2.29323Z"
        fill="currentColor"
      />
    </svg>
  ),
});
